export const PLAN_500_MB_DATA_SIZE = 500
export const PLAN_500_MB_RUNNING_LOW_THRESHOLD = 100
export const DEFAULT_PLAN_RUNNING_LOW_THRESHOLD = 500
